<div class="col w100 gap-16">
    <div class="row gap-16 space-between w100">
        <rr-icon class="roundicon" color="nutral" name="share"></rr-icon>
        <!-- <img src="/images/default-agent.png" alt="" /> -->
    </div>
    <div class="w100 col gap-8">
        <h3 i18n>Share Project</h3>
        <p>Share your asset using the link below</p>
    </div>
</div>
<div class="linkarea col gap-8" i18n>
    <div class="gap-8 w100 align-center">
        <div class="tiny sharelink" title="{{ shareLink }}">
            <span>Link:</span>

            <rr-btn type="Link" size="Small" class="w16 pointer" (btnclick)="openLink()">
                {{ shareLink }}
            </rr-btn>
        </div>
    </div>
    <div class="resultmsg {{ resulttype }}">{{ resultmsg }}</div>
</div>
<div class="btnrow row gap-8 w100 align-center space-between" i18n>
    <rr-btn type="Link" size="Small" iconStart="link" class="w16 pointer" (btnclick)="copyToClipboard()">Copy Share
        Link</rr-btn>
    <rr-btn type="Primary" size="Medium" (btnclick)="close()">Close</rr-btn>
</div>
